import React, { FC, useState } from 'react'
import { ComboboxInput } from 'components/ComboboxInput'
import { useGeoserch } from 'services/geosearch'
import { Text } from 'components/Text'
import { GeosearchResult, LocationSearch } from 'models/geosearch'

type GeoSearchProps = {
  onSelect: (location: LocationSearch | null) => void
  placeholder: string
  name: string
  initialValue?: string
  className?: string
}

export const GeoSearch: FC<GeoSearchProps> = ({
  name,
  placeholder,
  initialValue = '',
  className,
  onSelect,
}) => {
  const [query, setQuery] = useState<string>()
  //const [validQuery, setValidQuery] = useState<boolean>()

  const { status, results, error } = useGeoserch(query, {})

  const onItemSelected = (item: GeosearchResult | undefined) => {
    onSelect(item ? { ...item, query: query! } : null)
  }

  const changeQuey = (quey: string | undefined) => {
    // console.log("eres ? " + validQuery)

    //if (validQuery) {
    //setQuery(quey)
    //}

  }


  const onKeyDownTest = (event: any) => {
    //console.log("eres k ? " + validQuery)

    if (event.code === 'Enter') {
      //setValidQuery(true);
      //changeQuey(query);
      console.log(event.srcElement.value)
      setQuery(event.srcElement.value)

    }

    else {
      //setValidQuery(false);
    }

  }

  document.addEventListener('keydown', onKeyDownTest)

  return (
    <ComboboxInput
      inputItems={results}
      name={name}
      placeholder={placeholder}
      className={className}
      initialValue={initialValue}
      onChange={changeQuey}
      onSelect={onItemSelected}
      state={{ type: status, message: error }}
      formatter={(item?) => (item ? item.name : '')}
      menuItem={(item) => <Text>{item.name}</Text>}
      autoFocus={true}
    />
  )
}

GeoSearch.displayName = 'GeoSearch'
